<header mat-dialog-title>
  <div class="header-title-content">
    <span *ngIf="customers">Modifica Cliente: {{ customers.name }} {{ customers.surname }}</span>
    <span *ngIf="!customers" class="new-item">Nuovo Cliente</span>
    <!-- <p>Debug: {{ customers | json }}</p> -->

  </div>

  <!-- <div class="header-actions" *ngIf="customer">
    <button mat-icon-button [mat-menu-trigger-for]="actionMenu">
      <mat-icon>more_vert</mat-icon>
    </button>
    <mat-menu x-position="before" overlapTrigger="false" #actionMenu="matMenu">
      <button mat-menu-item (click)="deleteUser()">
        <mat-icon>delete</mat-icon>
        Elimina Utente
      </button>
    </mat-menu>
  </div> -->
</header>

<mat-dialog-content>
  <form *ngIf="customerForm" [formGroup]="customerForm" novalidate>
    <div class="u-flex-full">
      <mat-form-field class="u-full-width">
        <mat-label>Nome</mat-label>
        <input matInput formControlName="name" placeholder="Nome" required/>
        <mat-error>Campo obbligatorio</mat-error>
      </mat-form-field>

      <mat-form-field class="u-full-width">
        <mat-label>Cognome</mat-label>
        <input matInput formControlName="surname" placeholder="Cognome" />
        <mat-error>Campo obbligatorio</mat-error>
      </mat-form-field>

      <mat-form-field class="u-full-width">
        <span matPrefix>+39 &nbsp;</span>
        <input type="phone" #phone matInput placeholder="Telefono" formControlName="phone">
        <!-- <mat-icon matSuffix>call</mat-icon> -->
        <mat-hint align="end">{{ phone.value.length }} / 10</mat-hint>
      </mat-form-field>
    </div>

    <div class="u-flex-full">
      <mat-form-field class="u-full-width">
        <mat-label>Email</mat-label>
        <input matInput formControlName="email" type="email" placeholder="Email" />
        <mat-error>Campo obbligatorio</mat-error>
      </mat-form-field>

      <mat-form-field class="u-full-width">
        <mat-label>Punti Fidelity Card</mat-label>
        <input matInput formControlName="fidelityCardPoints" type="number" placeholder="Punti Fidelity Card" />
        <!-- <mat-error>Campo obbligatorio</mat-error> -->
      </mat-form-field>


      <mat-form-field class="u-full-width">
        <mat-label>Stato</mat-label>
        <mat-select formControlName="active">
          <mat-option [value]="true">Attivo</mat-option>
          <mat-option [value]="false">Disattivato</mat-option>
        </mat-select>
      </mat-form-field>
    </div>

    <div class="u-flex-full">
    <mat-form-field class="u-full-width">
      <mat-label>Note</mat-label>
      <textarea matInput formControlName="notes" placeholder="Note"></textarea>
    </mat-form-field>
    </div>
  </form>

  <div *ngIf="customers">
    <h2>Indirizzi</h2>

    <div *ngFor="let address of customer.addresses">
      <p class="address">&bull; {{ address.formattedAddress }} </p>
      <!-- <p class="address">&bull; {{ address.formattedAddress }} <span class="zone">[ {{ address.zone?.name }} ]</span></p> -->

    </div>
  </div>

  <!-- <div class="orders">

    <h3>Ordini</h3>

    <mat-tab-group class="u-margin-y">
      <mat-tab label="Statistiche">

        <p>Ordini effettuati: 0</p>
         <p>Media importo ordini: {{ customer.ordersAvg | number:'1.2-2' }}€</p> 

        <div *ngIf="ordersChartData?.datasets?.length > 0">
            <canvas
                baseChart
                chartType='line'
                [datasets]="ordersChartData.datasets"
                [labels]="ordersChartData.labels"
                [options]="ordersChartData.options">
            </canvas>
        </div>
      </mat-tab>

      <mat-tab label="Lista (0)">
         label="Lista ({{ customer.orders.length }})"
        <ng-template matTabContent>
          <div style="padding: 0 30px">

            <mat-accordion *ngIf="!(loading$ | async)">

              <mat-expansion-panel *ngFor="let order of orders">

                <mat-expansion-panel-header>
                  <mat-panel-title>
                    <mat-chip *ngIf="order.address?.zone" class="zone-chip" color="primary">{{ order.address?.zone?.name }}</mat-chip>
                    {{ order.address ? order.address?.doorBell : order.customer.name }}
                  </mat-panel-title>
                  <mat-panel-description>
                    {{ order.deliveryDate | date: 'dd/MM/yyyy' }}
                  </mat-panel-description>
                </mat-expansion-panel-header>

                <ul>
                  <li *ngFor="let productInOrder of order.productsInOrder" style="width: 100%">
                    {{ productInOrder.product.name }}
                    <span style="float: right">{{ productInOrder.amount }}€</span>
                    <ul *ngIf="productInOrder.variations" style="list-style-type: none">
                      <li *ngFor="let variation of productInOrder.variations">
                        <span class="title" *ngIf="variation.type == 'none'">Senza: </span>
                        <span class="title" *ngIf="variation.type == 'less'">Meno: </span>
                        <span class="title" *ngIf="variation.type == 'more'">Piu': </span>
                        <span class="title" *ngIf="variation.type == 'add'">In aggiunta: &nbsp;</span>
                        <span>{{ variation.ingredient?.name }}</span>
                      </li>
                    </ul>
                  </li>
                </ul>

                <mat-divider></mat-divider>

              </mat-expansion-panel>

              <h3 *ngIf="orders.length == 0">Questo cliente non ha mai effettuato ordini.</h3>

            </mat-accordion>
          </div>
        </ng-template>
      </mat-tab>
    </mat-tab-group>

  </div> -->

</mat-dialog-content>

<mat-dialog-actions>
  <div class="left-actions">
    <span>
      <button mat-raised-button (click)="revert()" [disabled]="customerForm.pristine">
        Reset
      </button>
      <button mat-raised-button color="primary" (click)="save()" [disabled]="customerForm.pristine || !customerForm.valid">
        Salva
      </button>
    </span>
  </div>
  <div class="right-actions">
    <button mat-raised-button (click)="close()">
      Chiudi
    </button>
  </div>
</mat-dialog-actions>

<!-- <div class="footer" *ngIf="loading$ | async">
<div class="spinner">
  <div class="rect1"></div>
  <div class="rect2"></div>
  <div class="rect3"></div>
  <div class="rect4"></div>
  <div class="rect5"></div>
</div>
</div> -->
